var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCategory = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.79615 5.18286L3.74995 5.18286C3.31253 5.18286 3.03913 4.69075 3.31253 4.36268L5.33563 1.0273C5.55434 0.699232 6.04644 0.699232 6.26516 1.0273L8.28826 4.36268C8.50697 4.74543 8.23358 5.18286 7.79615 5.18286Z",
    fill: "#11AC46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.76604 11.1945C1.40713 11.1945 0.30551 10.0929 0.30551 8.73396C0.30551 7.37505 1.40713 6.27344 2.76604 6.27344C4.12495 6.27344 5.22656 7.37505 5.22656 8.73396C5.22656 10.0929 4.12495 11.1945 2.76604 11.1945Z",
    fill: "#11AC46"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.86685 6.54687L10.1476 6.54687C10.4209 6.54687 10.6943 6.82027 10.6943 7.09366L10.6943 10.3744C10.6943 10.6478 10.4209 10.9211 10.1476 10.9211L6.86685 10.9211C6.59346 10.9211 6.32007 10.6478 6.32007 10.3744L6.32007 7.09366C6.32007 6.82027 6.59346 6.54687 6.86685 6.54687Z",
    fill: "#11AC46"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCategory);
export default ForwardRef;